import { Stack } from '@src/components';
import TimeSelectField from '@src/corelib/forms/generic/TimeSelectField';
import type { ComponentPropsWithoutRef } from 'react';

type TimeSelectFieldProps = ComponentPropsWithoutRef<typeof TimeSelectField>;

function TimeFromField(props: TimeSelectFieldProps) {
  return <TimeSelectField label="From" name="startTime" {...props} />;
}
function TimeToField(props: TimeSelectFieldProps) {
  return <TimeSelectField label="To" name="endTime" {...props} />;
}

export default function TimeRangeField() {
  return (
    <Stack spacing={2} direction="row">
      <TimeFromField minutesStep={15} />
      <TimeToField minutesStep={15} />
    </Stack>
  );
}
